import { useEffect, useState } from "react";
import {
  Box,
  Text,
  Flex,
  List,
  Radio,
  Switch,
  Button,
  Spinner,
  Divider,
  useToast,
  ListItem,
  FormLabel,
  RadioGroup,
  FormControl,
} from "@chakra-ui/react";
import { useFormik } from "formik";

import { useUserContext } from "context/UserContext";
import Topbar from "components/topbar";
import MainLayout from "components/mainLayout";
import FormikInput from "components/formikInput";
import FormikSelect from "components/formikSelect";
import FormikTextArea from "components/formikTextArea";
import useGetCharities from "api/queries/useGetCharities";
import useEditProfile from "api/mutations/useEditProfile";
import useGetSellerProfile from "api/queries/useGetSellerProfile";
import * as Yup from "yup";

const Profile = () => {
  const toast = useToast();
  const { user, setUser, signOut } = useUserContext();

  const charityQuery = useGetCharities();
  const charities = charityQuery?.data?.data || [];

  const validationSchema = Yup.object({
    address: Yup.string().required("Address is required"),
    city: Yup.string().required("City is required"),
    postcode: Yup.string().required("Postcode is required"),
  
    password: Yup.string()
      .min(8, "Password must be at least 8 characters long"),
    confirmPassword: Yup.string()
      .oneOf([Yup.ref("password"), null], "Passwords do not match")
      .when("password", {
        is: (password) => password?.length > 0,
        then: (schema) => schema.required("Please confirm your password"),
      }),
  });
  
  

  const formik = useFormik({
    initialValues: {
      _id: user?.info?._id,
      id: user?.id,
      title: "",
      first_name: "",
      surname: "",
      email_address: "",
      contact_number: "",
      address: "",
      city: "",
      postcode: "",
      bank_name: "",
      account_number: "",
      sort_code: "",
      international_bank_name: "",
      international_account_number: "",
      international_sort_code: "",
      rejected_item_action: "",
      discount: false,
      charity: null,
      password: "",
      confirmPassword: "",
    },
    validationSchema,
    validateOnChange: true,
    validateOnBlur: true,
    onSubmit: (values) => handleSubmit(values),
  });
  const [isInternationalChecked, setIsInternationalChecked] = useState(false);

  const sellerQuery = useGetSellerProfile({
    seller_id: user?.info?._id,
  });

  console.log('Formik', formik);
  useEffect(() => {
    const data = sellerQuery?.data?.data;
    console.log('Data', data);
    if (data) {
      formik.setValues({
        ...formik.values,
        id: data?.id,
        title: data.title,
        first_name: data.first_name,
        surname: data.surname,
        email_address: data.email_address,
        contact_number: data.contact_number,
        address: data.address,
        city: data.city,
        postcode: data.postcode,
        bank_name: data.bank_name,
        account_number: data.account_number,
        sort_code: data.sort_code,
        international_bank_name: data.international_bank_name,
        international_account_number: data.international_account_number,
        international_sort_code: data.international_sort_code,
        discount: data?.discount,
        rejected_item_action: data.rejected_item_action,
        charity: data?.charity,
        password: "",
        confirmPassword: "",
      });
    }
  }, [sellerQuery?.data]);

  useEffect(() => {
    if (
      formik.values.rejected_item_action === "Return to me" ||
      formik.values.rejected_item_action === "Returned"
    ) {
      formik.setFieldValue("charity", null);
    }
  }, [formik.values.rejected_item_action]);

  const editMutation = useEditProfile({
    onSuccess: (res) => {
      const updatedData = res?.data?.data; // seller data after update
      const sentData = res?.config?.data ? JSON.parse(res.config.data) : {};
  
      if (sentData?.password) {
        signOut();
        toast({
          title: "Password has been changed successfully",
          status: "success",
          duration: 1000,
        });
      } else {
        // Other fields changed => update user state only
        setUser((prev) => ({
          ...prev,
          info: updatedData,
        }));
        toast({
          title: "Profile edited successfully",
          status: "success",
          duration: 1500,
        });
      }
    },
    onError: () => {
      toast({
        title: "Failed to update profile",
        status: "error",
        duration: 1500,
      });
    },
  });
  

const handleSubmit = (values) => {
  console.log("values", values);

  const submitValues = { ...values };

  if (!values.password) {
    delete submitValues.password;
    delete submitValues.confirmPassword;
  } else {
    delete submitValues.confirmPassword;
  }

  // ✅ use submitValues, not values
  editMutation.mutate(submitValues);
}
  return (
    <MainLayout>
      <Box minH={"100vh"} h={"100%"}>
        <Topbar title={" Profile"} />
        <Flex bg={"#f8fbff"} padding={4} gap={2}>
          <Flex
            flex={1}
            direction={"column"}
            justifyContent={"space-between"}
            bg={"#FFFFFF"}
            padding={6}
            maxHeight={"100%"}
            borderRadius={"16px"}
            gap={4}
          >
            {/* <Box> */}
            <Text
              fontFamily={"PlusJakartaSansSemiBold"}
              fontSize={"24px"}
              lineHeight={"32px"}
              textTransform={"capitalize"}
              color={"#000000"}
            >
              Personal Details
            </Text>
            <Divider my={6} bg={"#8A8F9333"} h={"1px"} />
            <Box>
              <Text
                fontFamily={"PlusJakartaSansSemiBold"}
                fontSize={"16px"}
                lineHeight={"20px"}
                textTransform={"capitalize"}
                color={"#000000"}
              >
                Personal Info
              </Text>
              <Flex
                gap={4}
                marginTop={2}
                borderWidth={"1px"}
                borderColor={"#D9D9D9"}
                borderStyle={"solid"}
                padding={4}
                borderRadius={"6px"}
                flexDirection={"column"}
              >
                <Flex gap={4}>
                  <FormikInput
                    formik={formik}
                    name="id"
                    label={"ID"}
                    // placeholder={"Enter title"}
                    disabled
                  />
                  <FormikInput
                    formik={formik}
                    name="title"
                    label={"Title"}
                    placeholder={"Enter title"}
                  />

                  <FormikInput
                    formik={formik}
                    name="first_name"
                    label={"First Name"}
                    placeholder={"Enter first name"}
                  />
                  <FormikInput
                    formik={formik}
                    name="surname"
                    label={"surname"}
                    placeholder={"Enter surname"}
                  />
                </Flex>
                <Flex gap={4}>
                  <FormikInput
                    formik={formik}
                    name="email_address"
                    label={"Email Address"}
                    placeholder={"Enter email address"}
                    disabled
                  />

                  <FormikInput
                    formik={formik}
                    name="contact_number"
                    label={"Phone Number"}
                    placeholder={"Enter phone number"}
                  />
                </Flex>

                <Flex gap={4}>
                  <FormikInput
                    name="password"
                    label="Change Password"
                    placeholder="Enter Your New Password"
                    isPassword={true}
                    formik={formik}
                  />
                  <FormikInput
                    name="confirmPassword"
                    label="Confirm Password"
                    placeholder="Confirm Your New Password"
                    isPassword={true}
                    formik={formik}
                  />
                </Flex>
                <FormikTextArea
                  formik={formik}
                  name="address"
                  label={"Address"}
                  placeholder={"Enter your address"}
                />
                <Flex gap={4}>
                  <FormikInput
                    formik={formik}
                    name="city"
                    label={"City"}
                    placeholder={"Enter your city"}
                  />

                  <FormikInput
                    formik={formik}
                    name="postcode"
                    label={"Post Code"}
                    placeholder={"Enter your post code"}
                  />
                </Flex>
              </Flex>
            </Box>
            {/* Bank Details */}
            <Box>
              <Text
                fontFamily={"PlusJakartaSansSemiBold"}
                fontSize={"16px"}
                lineHeight={"20px"}
                textTransform={"capitalize"}
                color={"#000000"}
                mt={4}
              >
                Bank Details
              </Text>
              <Flex
                gap={4}
                marginTop={2}
                borderWidth={"1px"}
                borderColor={"#D9D9D9"}
                borderStyle={"solid"}
                padding={4}
                borderRadius={"6px"}
                flexDirection={"column"}
              >
                <Flex gap={4}>
                  <FormikInput
                    formik={formik}
                    name="bank_name"
                    label={"Bank Name"}
                    placeholder={"Enter your bank name"}
                  />

                  <FormikInput
                    formik={formik}
                    name="account_number"
                    label={"Account Number"}
                    placeholder={"Enter account number"}
                  />
                </Flex>
                {/* <FormikInput
                  formik={formik}
                  name="sort_code"
                  label={"Sort Code"}
                  placeholder={"Enter sort code"}
                /> */}
                <FormControl
                  display="flex"
                  alignItems="center"
                  justifyContent="space-between"
                >
                  <FormLabel
                    htmlFor="remember-me"
                    mb="0"
                    fontFamily={"PlusJakartaSansMedium"}
                    fontSize={"12px"}
                    lineHeight={"20px"}
                    textTransform={"capitalize"}
                    color={"#000000"}
                    mx={1}
                  >
                    INTERNATIONAL BANK DETAILS
                  </FormLabel>
                  <Switch
                    id="remember-me"
                    colorScheme={"success"}
                    onChange={() => setIsInternationalChecked((p) => !p)}
                  />
                </FormControl>
                {isInternationalChecked && (
                  <Flex flexDir={"column"} gap={4}>
                    <Flex gap={4}>
                      <FormikInput
                        formik={formik}
                        name="international_sort_code"
                        label={"Sort Code"}
                        placeholder={"Enter international sort code"}
                      />
                      <FormikInput
                        formik={formik}
                        name="international_bank_name"
                        label={"Account Holder Name"}
                        placeholder={"Enter international bank name"}
                      />
                    </Flex>
                    <FormikInput
                      formik={formik}
                      name="international_account_number"
                      label={"International Bank Details"}
                      placeholder={"Enter international account number"}
                    />
                  </Flex>
                )}
              </Flex>
            </Box>
            {/* Discount */}
            <Box>
              <Text
                fontFamily={"PlusJakartaSansSemiBold"}
                fontSize={"16px"}
                lineHeight={"20px"}
                textTransform={"capitalize"}
                color={"#000000"}
                mt={4}
              >
                Discount Details
              </Text>
              <Flex
                gap={4}
                marginTop={2}
                borderWidth={"1px"}
                borderColor={"#D9D9D9"}
                borderStyle={"solid"}
                padding={4}
                borderRadius={"6px"}
                flexDirection={"column"}
              >
                {/* <Flex gap={4}>
                  <FormikInput
                    formik={formik}
                    name="bank_name"
                    label={"Bank Name"}
                    placeholder={"Enter your bank name"}
                  />

                  <FormikInput
                    formik={formik}
                    name="account_number"
                    label={"Account Number"}
                    placeholder={"Enter account number"}
                  />
                </Flex> */}
                <Flex direction={"column"} gap={2}>
                  <Flex
                    flex={1}
                    justify={"space-between"}
                    alignItems={"center"}
                  >
                    <FormLabel
                      fontFamily={"PlusJakartaSansMedium"}
                      fontSize={12}
                      color={"#000000"}
                      margin={0}
                    >
                      Do you want us to decrease the price by 10% every 3
                      months?
                    </FormLabel>
                    <RadioGroup
                      name="discount"
                      value={
                        formik?.values?.discount !== null
                          ? formik?.values?.discount.toString()
                          : ""
                      }
                      onChange={(val) => {
                        formik.setFieldValue("discount", val === "true");
                      }}
                    >
                      <Flex>
                        <Radio
                          value="true"
                          fontFamily={"PlusJakartaSansMedium"}
                          fontSize={12}
                          mr={28}
                          color={"#000000"}
                        >
                          Yes
                        </Radio>
                        <Radio
                          value="false"
                          fontFamily={"PlusJakartaSansMedium"}
                          fontSize={12}
                          color={"#000000"}
                        >
                          No
                        </Radio>
                      </Flex>
                    </RadioGroup>
                  </Flex>
                  <Box
                    bg="#D9D9D966"
                    p={2}
                    borderRadius="4px"
                    display="inline-block"
                    maxW="max-content"
                  >
                    <List spacing={1} styleType="disc" pl={3}>
                      <ListItem
                        fontSize={"8px"}
                        fontFamily={"PlusJakartaSansRegular"}
                        color={"#000000"}
                      >
                        To help sell items will be automatically reduced by 10%
                        every 3 month up to a maximum of 80% off RRP
                      </ListItem>
                    </List>
                  </Box>
                </Flex>
              </Flex>
            </Box>
            {/* Rejected Products */}
            <Box>
              <Text
                fontFamily={"PlusJakartaSansSemiBold"}
                fontSize={"16px"}
                lineHeight={"20px"}
                textTransform={"capitalize"}
                color={"#000000"}
                mt={4}
              >
                Rejected Products
              </Text>
              <Flex
                gap={4}
                marginTop={2}
                borderWidth={"1px"}
                borderColor={"#D9D9D9"}
                borderStyle={"solid"}
                padding={4}
                borderRadius={"6px"}
                flexDirection={"column"}
              >
                <FormikSelect
                  formik={formik}
                  name="rejected_item_action"
                  label={"what to do with rejected products"}
                  onChangeCapture={() => {
                    formik.setFieldValue("charity", charities[0]?._id);
                  }}
                >
                  <option value="Donate to charity">Donate to charity</option>
                  <option value="Return to me">Return to me</option>
                </FormikSelect>
                {formik?.values?.rejected_item_action
                  ?.replace(/\u00A0/g, " ")
                  .trim() === "Donate to charity" ? (
                  <FormikSelect
                    formik={formik}
                    name="charity"
                    label={"Select charity you wish to donate."}
                    placeholder={"select charity"}
                  >
                    {charities.map((charity) => (
                      <option key={charity._id} value={charity._id}>
                        {charity.name}
                      </option>
                    ))}
                  </FormikSelect>
                ) : null}
              </Flex>
            </Box>

            {/* </Box> */}

            <Flex
              alignSelf={"flex-end"}
              justifyContent={"flex-end"}
              w={"100%"}
              gap={2}
              mt={4}
            >
              {/* <Button
                onClick={handleCancel}
                flex={1}
                maxW={"148px"}
                background={"transparent"}
                color={"#000000"}
                border={"1px solid #000000"}
                borderRadius={8}
                fontSize={"12px"}
                fontFamily={"PlusJakartaSansMedium"}
                textTransform={"uppercase"}
              >
                Cancel
              </Button> */}
              <Button
                onClick={formik.handleSubmit}
                flex={1}
                maxW={"148px"}
                background={"#000000"}
                color={"#FFFFFF"}
                borderRadius={8}
                fontSize={"12px"}
                fontFamily={"PlusJakartaSansMedium"}
                textTransform={"uppercase"}
                isDisabled={editMutation.isLoading}
                _disabled={{
                  bg: "grey.100",
                  cursor: "default",
                  _hover: {
                    bg: "grey.100",
                    cursor: "default",
                  },
                }}
              >
                {editMutation.isLoading ? <Spinner /> : " Save"}
              </Button>
            </Flex>
          </Flex>
        </Flex>
      </Box>
    </MainLayout>
  );
};

export default Profile;
